import { ROAD_SPIN_AREA } from '@goodtime/shared';

/** Room the slot needs below the reels for the SPIN row and HUD. */
export const SPIN_AREA = ROAD_SPIN_AREA;

/**
 * Vertical placement of the reels when the host reserves room above and
 * below them (the Royal Road panel and trail). Returns the largest scale the
 * height allows and the y of the reel grid's top edge, just under the top
 * inset.
 */
export function placeBetweenInsets(opts: {
  height: number;
  naturalHeight: number;
  top: number;
  bottom: number;
  ring: number;
  scale: number;
}): { maxScale: number; machineY: number } {
  const room = Math.max(0, opts.height - opts.top - opts.bottom - SPIN_AREA);
  const maxScale = Math.max(0.5, (room - opts.ring * 2) / opts.naturalHeight);
  // The reels sit straight under the panel (its inset already keeps room for
  // the slot's chips); any height left over goes below SPIN, not into a gap
  // between the panel and the reels.
  const machineY = Math.round(opts.top + opts.ring);
  return { maxScale, machineY };
}
